import { dbCreateError } from './api-functions';

export default function submitError(type, description) {
    console.log(`${type}, ${description}`);
	dbCreateError({type, description});
}